// leverandorer.js
export const leverandorer = [
  {
    navn: "Michelin",
    logo: "/img/leverandorer/logo1.png",
    kontaktpersoner: [
      {
        navn: "Ida Sjursen",
        rolle: "Account Manager",
        bilde: "/img/leverandorer/personer/logo1-1.jpg",
        tlf: "901 10 849",
        epost: "ida.sjursen@michelin.com",
      },
      {
        navn: "Didrik Launes",
        rolle: "Account Manager",
        bilde: "/img/leverandorer/personer/logo1-2.jpg",
        tlf: "944 33 300",
        epost: "didrik.launes@michelin.com",
      },
    ],
  },
  {
    navn: "Goodyear",
    logo: "/img/leverandorer/logo2.png",
    kontaktpersoner: [
      {
        navn: "Christoffer Robertsen",
        rolle: "Key Account Manager",
        bilde: "/img/leverandorer/personer/logo2-1.jpg",
        tlf: "906 32 730",
        epost: "christopher_robertsen@goodyear.com",
      },
      {
        navn: "Petter Bibow Handeland",
        rolle: "Key Account Manager",
        bilde: "/img/leverandorer/personer/logo2-2.jpg",
        tlf: "911 06 338",
        epost: "petter_handeland@goodyear.com",
      },
    ],
  },
  {
    navn: "Continental",
    logo: "/img/leverandorer/logo3.png",
    kontaktpersoner: [
      {
        navn: "Erik Eidem",
        rolle: "Head of Sales",
        bilde: "/img/leverandorer/personer/logo3-1.jpg",
        tlf: "905 06 117",
        epost: "erik.eidem@continental.com",
      },
      {
        navn: "Truls Skramrud-Thire",
        rolle: "Distriktssjef",
        bilde: "/img/leverandorer/personer/logo3-2.jpg",
        tlf: "934 0 7597",
        epost: "truls.skramrud.thire@continental.com",
      },
    ],
  },
  {
    navn: "Nokian",
    logo: "/img/leverandorer/logo4.png",
    kontaktpersoner: [
      {
        navn: "Asle Kristoffer Medgard",
        rolle: "Salgsjef",
        bilde: "/img/leverandorer/personer/logo4-1.jpg",
        tlf: "907 21 876",
        epost: "akm@nokiantyres.com",
      },
      {
        navn: "Lars Holmboe Lie",
        rolle: "Salgssjef - Lastebil og Bussdekk",
        bilde: "/img/leverandorer/personer/logo4-2.jpg",
        tlf: "930 02 615",
        epost: "lars.lie@nokiantyres.com",
      },
    ],
  },
  {
    navn: "Starco",
    logo: "/img/leverandorer/logo5.png",
    kontaktpersoner: [
      {
        navn: "Aleksander Ragnem",
        rolle: "salgsdirektør",
        bilde: "/img/leverandorer/personer/logo5-1.jpg",
        tlf: "402 25 653",
        epost: "aleksander.ragnem@starco.no",
      },
      {
        navn: "Petter Opsahl",
        rolle: "Key Account Manager / Leder Innesalg",
        bilde: "/img/leverandorer/personer/logo5-2.jpg",
        tlf: "454 56 829",
        epost: "petter.opsahl@starco.no",
      },
      {
        navn: "Håvard Nilsen",
        rolle: "Distriktssjef Sør",
        bilde: "/img/leverandorer/personer/logo5-3.jpg",
        tlf: "959 01 615",
        epost: "haavard.nilsen@starco.no",
      },
    ],
  },
  {
    navn: "Norgesdekk",
    logo: "/img/leverandorer/logo6.png",
    kontaktpersoner: [
      {
        navn: "Ansgar Alm Raastad",
        rolle: "Daglig leder",
        bilde: "/img/leverandorer/personer/logo6-1.webp",
        tlf: "922 42 441",
        epost: "ansgar@norgesdekk.no",
      },
    ],
  },
  {
    navn: "NDI",
    logo: "/img/leverandorer/logo7.png",
    kontaktpersoner: [
      {
        navn: "Roger Hjelmen",
        rolle: "Distriktssjef Trøndelag og Nordland sør for Ballangen",
        bilde: "/img/leverandorer/personer/logo7-1.png",
        tlf: "400 06 019",
        epost: "rohj@ndi-no.com",
      },
      {
        navn: "Kent Robert Bøe",
        rolle: " Distriktssjef",
        bilde: "/img/leverandorer/personer/logo7-2.jpg",
        tlf: "951 27 004",
        epost: "kerbo@ndi-no.com",
      },
    ],
  },
  {
    navn: "Lilleseth Kjetting",
    logo: "/img/leverandorer/logo8.png",
    kontaktpersoner: [
      {
        navn: "Stian Østerhaug",
        rolle: "Salgssjef.",
        bilde: "/img/leverandorer/personer/logo8-1.jpg",
        tlf: "930 41 192",
        epost: "stian@lilleseth.no",
      },
    ],
  },
  {
    navn: "Gjerde & Byhring",
    logo: "/img/leverandorer/logo9.png",
    kontaktpersoner: [
      {
        navn: "Christian Knudsen",
        rolle: "Salgssjef Østlandet",
        bilde: "/img/leverandorer/personer/logo9-1.jpg",
        tlf: "900 12 221",
        epost: "knudsen@bridgestone.no",
      },
    ],
  },
  {
    navn: "MEKO",
    logo: "/img/leverandorer/logo10.png",
    kontaktpersoner: [
      {
        navn: "Petter Myhre",
        rolle: "Key Account Manager",
        bilde: "/img/leverandorer/personer/logo10-1.jpg",
        tlf: "900 52 636",
        epost: "petter.myhre@meko.com",
      },
    ],
  },
  {
    navn: "Scandekk",
    logo: "/img/leverandorer/logo11.png",
    kontaktpersoner: [
      {
        navn: "Nils Georg Lundberg",
        rolle: "Salgsansvarlig",
        bilde: "/img/leverandorer/personer/logo11-1.jpg",
        tlf: "926 38 115",
        epost: "n.g.lund@gmail.com",
      },
    ],
  },
  {
    navn: "Nøsted Kjetting",
    logo: "/img/leverandorer/logo12.png",
    kontaktpersoner: [
      {
        navn: "Ketil Høstad",
        rolle: "District Sales Manager, Central and Northern Norwa",
        bilde: "/img/leverandorer/personer/logo12-1.jpg",
        tlf: "918 26 411",
        epost: "ketil.hostad@nosted.com",
      },
      {
        navn: "Erik Espelund",
        rolle: "District Sales Manager, Western Norway",
        bilde: "/img/leverandorer/personer/logo12-2.png",
        tlf: "918 44 029",
        epost: "erik.epselund@nosted.com",
      },
    ],
  },
];
